import { Injectable } from '@angular/core';
import { Query } from '@datorama/akita';
import { OtpStore, OtpState } from './otp.store';

@Injectable({ providedIn: 'root' })
export class OtpQuery extends Query<OtpState> {

  constructor(protected store: OtpStore) {
    super(store);
  }

}
